import { Box, Button, Divider, Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import axios from "axios";
import { AuthState } from "context/AuthContext";
import { GlobalState } from "context/GlobalContext";
import { createdByColumns } from "data/globalData";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import { ReplenishmentState } from "context/ReplenishmentContext.js";
import { replExecuteLogicsPath } from "../../data";
import VerticalProcessStepper from "./VerticalProcessStepper/VerticalProcessStepper";
import { progressSteps } from "./data";
import moment from "moment";
import ResultsTab from "./ResultsTab/ResultsTab";

const tabStyle = { p: 2 };
const SelectedJob = ({ activeService }) => {
	const { setSnackBar, setSnackBarOpen, snackBar, setLoadingOpen, Loadingopen } = GlobalState();
	const navigate = useNavigate();

	const [pageData, setPageData] = useState(null);
	let [searchParams, setSearchParams] = useSearchParams();
	const [tabIndex, setTabIndex] = useState(0);
	const [stepsData, setStepsData] = useState([]);
	const [resultData, setResultData] = useState();

	useEffect(() => {
		const fetch = async () => {
			setLoadingOpen(true);
			setPageData();
			try {
				await axios.get(`/api/replenishment/get_repl_job_by_id/${id}`).then(async (res) => {
					const job = res?.data?.result;
					await axios.get(`/api/replenishment/get_logic_profile_by_id/${job?.profile_id}`).then((res) => {
						setPageData({
							...job,
							profile_data: res?.data?.result,
						});
						setStepsData(job.progress);
					});
					setLoadingOpen(false);
				});
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrMsgFromError(error) });
				setLoadingOpen(false);
			}
		};
		let id = searchParams.get("id");
		if (id && id !== pageData?.job_id) fetch();
		else {
			setPageData(null);
		}
	}, [searchParams]);

	const goToAllExecuteJobsPath = () => {
		navigate(`/${replExecuteLogicsPath}`);
	};
	const handleTabChange = (_, newValue) => {
		setTabIndex(newValue);
	};
	const getLatestStepsData = async () => {
		try {
			const res = await axios.get(`/api/replenishment/get_job_progress_by_id/${pageData?.job_id}`);
			// console.log(res.data?.result, pageData, "nvfrhgsdjfjs");
			const data = res.data?.result;
			if (data.completed) {
				setResultData(data.result);
				if (!pageData.completed) setTabIndex(1);
				setPageData((prev) => ({ ...prev, ...data }));
			}

			return data.progress;
		} catch (error) {
			console.log("polling Error", parseErrMsgFromError(error));
		}
	};
	if (pageData)
		return (
			<Stack>
				<Divider />
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Box display="flex" justifyContent="space-between" alignItems="center">
						<Tabs value={tabIndex} onChange={handleTabChange}>
							<Tab label="Progress" />
							<Tab label="Result" />
						</Tabs>
					</Box>
					<Box display="flex" columnGap={2}>
						<Typography variant="body1">
							Profile: <span style={{ fontWeight: "bold" }}>{pageData?.profile_data.profile_name}</span>
						</Typography>
						<Typography variant="body1">
							Created:{" "}
							<span style={{ fontWeight: "bold" }}>{moment(pageData?.created_at).format("DD/MM/YY") + " "} </span>
							{moment(pageData?.created_at).format("HH:MS")}
						</Typography>
					</Box>
				</Box>

				{tabIndex === 0 && (
					<Box sx={tabStyle}>
						<VerticalProcessStepper
							stepsData={stepsData}
							setStepsData={setStepsData}
							// stepsList={progressSteps}
							labelCol="label"
							keyCol="process"
							getLatestStepsData={getLatestStepsData}
						/>
					</Box>
				)}
				{tabIndex === 1 && (
					<Box
						// hidden={tabIndex !== 1}
						sx={tabStyle}>
						<ResultsTab fullData={pageData} resultData={resultData} setResultData={setResultData} resultKey="result" />
					</Box>
				)}
			</Stack>
		);
	else {
		if (!Loadingopen)
			return (
				<Stack display="flex" justifyContent="center" alignItems="center" height="100%" spacing={1}>
					<Typography variant="h5" p={2}>
						---- No Job Id Found ----
					</Typography>
					<Button variant="contained" sx={{ textTransform: "capitalize" }} onClick={goToAllExecuteJobsPath}>
						Go to All Profiles
					</Button>
				</Stack>
			);
	}
};

export default SelectedJob;
